var _path, _path2, _path3, _path4, _rect, _rect2, _rect3;

var _excluded = ["svgRef", "title"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var SvgNotExpired = function SvgNotExpired(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 28,
    height: 31,
    viewBox: "0 0 28 31",
    fill: "none",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M23.5 13.8571C23.5 15.4938 22.3345 17.0733 20.2372 18.2718C18.1541 19.4621 15.2428 20.2143 12 20.2143C8.75718 20.2143 5.84595 19.4621 3.76279 18.2718C1.66548 17.0733 0.5 15.4938 0.5 13.8571C0.5 12.2205 1.66548 10.641 3.76279 9.44253C5.84595 8.25215 8.75718 7.5 12 7.5C15.2428 7.5 18.1541 8.25215 20.2372 9.44253C22.3345 10.641 23.5 12.2205 23.5 13.8571Z",
    fill: "#FDC742",
    stroke: "#FDC742"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M23.9072 16.4286C23.169 19.8111 18.1194 22.4286 12 22.4286C5.88057 22.4286 0.830988 19.8111 0.0928406 16.4286C0.031565 16.7094 0 16.9955 0 17.2857C0 21.0728 5.37258 24.1429 12 24.1429C18.6274 24.1429 24 21.0728 24 17.2857C24 16.9955 23.9684 16.7094 23.9072 16.4286Z",
    fill: "#FDC742"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M23.9072 19.8572C23.169 23.2397 18.1194 25.8572 12 25.8572C5.88057 25.8572 0.830988 23.2397 0.0928406 19.8572C0.031565 20.138 0 20.424 0 20.7143C0 24.5014 5.37258 27.5715 12 27.5715C18.6274 27.5715 24 24.5014 24 20.7143C24 20.424 23.9684 20.138 23.9072 19.8572Z",
    fill: "#FDC742"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M23.9072 23.2858C23.169 26.6683 18.1194 29.2858 12 29.2858C5.88057 29.2858 0.830988 26.6683 0.0928406 23.2858C0.031565 23.5666 0 23.8526 0 24.1429C0 27.93 5.37258 31.0001 12 31.0001C18.6274 31.0001 24 27.93 24 24.1429C24 23.8526 23.9684 23.5666 23.9072 23.2858Z",
    fill: "#FDC742"
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 14.5,
    y: 0.5,
    width: 13,
    height: 13,
    rx: 6.5,
    fill: "#FDC742",
    stroke: "#FFF2D1"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 20,
    y: 9,
    width: 7,
    height: 2,
    rx: 1,
    transform: "rotate(-90 20 9)",
    fill: "#FFF2D1"
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    x: 20,
    y: 12,
    width: 2,
    height: 2,
    rx: 1,
    transform: "rotate(-90 20 12)",
    fill: "#FFF2D1"
  })));
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgNotExpired, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/not_expired.bf9319f5.svg";
export { ForwardRef as ReactComponent };